class PGSServiceConnection {
  constructor(url) {
    this.url = url;
  }

  /** Llama a una funcion del servicio biometrico de pgs
   * @param {string} path
   * @param {"POST"|"PUT"|"GET"|"DELETE"} method
   * @param {{[key:string]:unknown}} [body]
   */
  async call(method, path, body, headers) {
    
    const callResponse = await fetch(`${this.url}/${path}`, {
      method: method,
      body: body ? JSON.stringify(body) : undefined,
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        ...(headers ? headers : {}),
      },
      signal: AbortSignal.timeout(5000),
    });
    return callResponse.json();
  }

  async textCall(method, path, body) {
    const callResponse = await fetch(`${this.url}/${path}`, {
      method: method,
      body: JSON.stringify(body),
      mode: "cors",
      headers: { "Content-Type": "text/plain" },
      signal: AbortSignal.timeout(5000),
    });
    return {
      status: callResponse.status,
      data: await callResponse.json(),
    };
  }
}

class PGSEnrollmentClient {
  /** @param {PGSServiceConnection} connection*/
  constructor(connection = new PGSServiceConnection()) {
    this.connection = connection;
    this.collection = "enrollment";
  }

  async beginEnrollment() {
    const res = await this.connection.call("POST",`${this.collection}/begin`);

    return res;
  }

  async addToEnrollment(fmd) {
    const res = await this.connection.call(
      "POST",
      `${this.collection}/add-fmd`,
      { fmd }
    );
    return res;
  }

  async endEnrollment() {
    const res = await this.connection.call("POST", `${this.collection}/end`);
    return res;
  }

  async cancelEnrollment() {
    const res = await this.connection.call("POST", `${this.collection}/cancel`);
    return res;
  }
}

class PGSFMDClient {
  /** @param {PGSServiceConnection} connection*/
  constructor(connection = new PGSServiceConnection()) {
    this.connection = connection;
    this.collection = "fmd";
  }

  async fromRaw(Vendor, Quality, Data) {
    const res = await this.connection.call(
      "POST",
      `${this.collection}/from-raw`,
      {
        Vendor,
        Quality,
        Data,
      }
    );
    return res;
  }
}

class PGSProxyClient {
  /** @param {PGSServiceConnection} connection*/
  constructor(connection = new PGSServiceConnection()) {
    this.connection = connection;
  }

  async call(config) {
    const res = await this.connection.textCall("POST", `proxy`, config);
    return res;
  }

  async checkHelth(){
    const res = await this.connection.call("GET","health")
  }
}

class RHEmployeeClient {
  /** @param {PGSServiceConnection} connection*/
  constructor(connection = new PGSServiceConnection()) {
    this.connection = connection;
    this.auth = `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MTcsIm5tZSI6InBnc2RldiIsInJscyI6WzEwXSwiZHB0cyI6WzEyLDEzLDE0XSwiY3B5Ijo1LCJ0bnQiOjIsImlhdCI6MTcwNDk5MzI5NywiZXhwIjoyMDIwNTY5Mjk3fQ.48GL6MWA_VlDxPC8nXy36mkR4C9OIuSNrrJiby5UK-c`;
  }

  async getEmployeeInfo(id) {
    const res = await this.connection.call("GET", `employee/${id}`, undefined, {
      Authorization: this.auth,
    });
    return res;
  }

  async writeAttendance(id, timestamp) {
    const res = await this.connection.call(
      "POST",
      `attendance-device`,
      {
        ATDE_EPE_ID: Number(id),
        ATDE_RECORD: timestamp,
      },
      {
        Authorization: this.auth,
      }
    );
    return res;
  }
}

export { PGSServiceConnection, PGSProxyClient, PGSFMDClient, PGSEnrollmentClient };
